import React, { memo, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./TalkToAnExpert.scss";
import { getInitialFormData } from "./utils/utils";
import { validateInput } from "./validations/validation";
import { COUNTRIES, FLAG_PATH_SRC, SUBMIT_FORM_API_STATUS_CODE, VALIDATION_MSGS } from "./constants/constants";
import useSubmitRequest from "./hooks/useSubmitRequest";
import { API_FETCH_STATUS } from "constants/common";
import { B2B_BASE_ASSETS_URL } from "constants/app";
import LineLoader from "components/lineLoader/lineLoader";
import { faTalkToAnExpertClick, faTalkToAnExpertLoad } from "./services/TalkToAnExpert.analytics";
const {
  custom_model_main,
  custom_model_inner,
  close_btn,
  custom_model_wrap,
  pop_up_content_wrap,
  thanks_msg,
  message_inside,
  form_wrapper,
  close_got_it,
  duplicate_msg,
  error_msg,
  form,
  form_inner_container,
  col_group,
  form_group,
  validation,
  alpaError,
  errorState,
  select_box,
  selected_option,
  c_flag,
  c_code,
  c_mobile,
  options,
  right_img_wrapper,
  bg_overlay,
  iconify,
  model_open,
  error,
  success,
  disabled,
  active,
  option,
  search_box,
  search_country,
  country_name,
  showMobileError,
  overflowYHidden,
} = styles;

const { SUCCESS, LOADING, ERROR } = API_FETCH_STATUS;
const { SUCCESS: SUBMIT_FORM_SUCCESS, DUPLICATE: SUBMIT_FORM_DUPLICATE, ERROR: SUBMIT_FORM_ERROR } = SUBMIT_FORM_API_STATUS_CODE;

export default function TalkToAnExpert({
  flowName = "",
  showTalkToAnExpert,
  setShowTalkToAnExpert,
  LeadProduct = "Connectivity",
  LineOfBusiness = "Connectivity",
  onSubmit,
}) {
  const [formData, setFormData] = useState(getInitialFormData(null));
  const { fullName, mobileNumber, country, companyName, companyEmail } = formData;
  const [showCountryList, setShowCountryList] = useState(false);
  const [countryList, setCountryList] = useState(country?.options);
  const [searchCountryName, setSearchCountryName] = useState("");
  const talkToAnExpertRef = useRef(null);
  const countrySelectBtnRef = useRef(null);
  const searchCountryNameRef = useRef(null);
  const setFormState = (data) => setFormData({ ...formData, ...data });
  const {
    submitFormData,
    status: submitFormStatus,
    setStatus: setSubmitFormStatus,
    content: submitFormContent,
  } = useSubmitRequest();

  const handleMouseDown = (target) => {
    if (talkToAnExpertRef.current?.contains(target)) {
      if (!countrySelectBtnRef.current?.contains(target) && !searchCountryNameRef.current?.contains(target))
        setShowCountryList(false);
      // updateSearchCountryList("");
    } else CloseTalkToAnExpert();
  };
  const onInputChange = (key, inputValue) => {
    let newField = { ...formData[key] };
    newField.value = inputValue;
    if (key == mobileNumber.name) {
      if (/\D/g.test(newField.value)) newField.value = newField.value.replace(/\D/g, "");
    }
    newField.error = validateInput(newField, formData);

    if(newField.error !== '') {
      newField.touched = true;
      if (key == fullName.name) {
        newField.value = newField.value.replace(/[^a-zA-Z\s]/g, "");
      }
    }else{
      newField.touched = false;
    }
    setFormState({ [key]: newField });
  };
  const onBlurChange = (key) => {
    let newField = { ...formData[key] };
    newField.touched = true;
    newField.error = validateInput(newField, formData);
    setFormState({ [key]: newField });
  };
  useEffect(() => {
    if (!showCountryList) updateSearchCountryList("");
  }, [showCountryList]);
  useEffect(() => {
    if (showTalkToAnExpert) {
      faTalkToAnExpertLoad(flowName);
      document.body.classList.add(overflowYHidden);
    } else {
      document.body.classList.remove(overflowYHidden);
    }
  }, [showTalkToAnExpert]);

  // close talk to an expert btn
  const CloseTalkToAnExpert = () => {
    setFormData(getInitialFormData(null));
    setSubmitFormStatus(null);
    setShowTalkToAnExpert(false);
    setShowCountryList(false);
  };
  const handleCountryClick = (countryValue) => {
    setShowCountryList(false);
    updateSearchCountryList("");
    setFormState({ country: { ...country, value: countryValue } });
  };
  const updateSearchCountryList = (countryName) => {
    setSearchCountryName(countryName);
    if (countryName == "") setCountryList(country.options);
    else setCountryList(country.options.filter((country) => country.name.toLowerCase().includes(countryName.toLowerCase())));
  };
  if(document.addEventListener('keydown', (e) => {
    if (e.key === "Escape") {
      CloseTalkToAnExpert();
    }
  }));

  if (!showTalkToAnExpert) return null;

  return (
    <div
      className={`${custom_model_main} ${showTalkToAnExpert ? model_open : ""}`}
      onMouseDown={(e) => handleMouseDown(e.target)}
      role="dialog"
      aria-modal="true"
      aria-labelledby="We’re here to help you"
      tabIndex={-1}
    >
      <div ref={talkToAnExpertRef} className={custom_model_inner}>
        <div className={custom_model_wrap}>
          <button
            className={close_btn}
            onClick={CloseTalkToAnExpert}
            aria-label="Close Dialog"
            type="button"
          >
            <i className="aeh-icon-Close" aria-hidden="true"></i>
          </button>
          <div className={pop_up_content_wrap}>
            <div className={form_wrapper}>
              {submitFormStatus == null ? (
                <>
                  {/* <!-- form start here --> */}
                  <form className={form} id="form" autoComplete="off" aria-labelledby="Talk to expert">
                    <h4 id="talk-to-expert-title">We’re here to help you</h4>
                    <div className={form_inner_container}>
                      <div className={` ${form_group}`}>
                        <div className={`${validation} ${fullName.touched ? (fullName.error ? error : success) : ""} `}>
                          <label htmlFor={fullName.name}>Full Name</label>
                          <input
                            id={fullName.name}
                            name={fullName.name}
                            placeholder={fullName.placeholder}
                            value={fullName.value}
                            onChange={(e) => onInputChange(fullName.name, e.target.value)}
                            onBlur={() => onBlurChange(fullName.name)}
                            onClick={() => faTalkToAnExpertClick({ flowName, formData, segment: "full name" })}
                            required={fullName.required}
                            type="text"
                            aria-required="true"
                            aria-invalid={!!fullName.error}
                            aria-describedby={`${fullName.name}-error`}
                          />
                          <small
                            id={`${fullName.name}-error`}
                            className={`${alpaError} ${errorState}`}
                            aria-live="polite"
                          >
                            {fullName.error}
                          </small>
                        </div>
                      </div>
                      <div className={` ${form_group} `}>
                        <div
                          className={`${select_box} ${validation} ${
                            mobileNumber.value ? (mobileNumber.error ? error : success) : ""
                          } `}
                        >
                          <label htmlFor={mobileNumber.name}>Mobile Number</label>
                          <div
                            className={`${selected_option} ${mobileNumber.touched ? (mobileNumber.error ? error : success) : ""}`}
                            id="mobile_error"
                          >
                            <div
                              className={c_flag}
                              ref={countrySelectBtnRef}
                              onClick={() => setShowCountryList(!showCountryList)}
                              tabIndex={0}
                              role="button"
                              aria-haspopup="listbox"
                              aria-expanded={showCountryList}
                              aria-label="Select country"
                              onKeyDown={e => {
                                if (e.key === "Enter" || e.key === " ") setShowCountryList(!showCountryList);
                              }}
                            >
                              <span className={iconify} data={country.value.name}>
                                <img src={`${FLAG_PATH_SRC}${country.value?.path} `} alt={`${country.value.name} flag`} />
                              </span>
                            </div>
                            <div className={`${c_code}`}>
                              <input
                                type="tel"
                                id="telecom"
                                value={`+${country.value.phone}`}
                                name="tel"
                                placeholder="+91"
                                disabled
                                aria-label="Country code"
                                tabIndex={-1}
                              />
                            </div>
                            <div className={`${c_mobile} ${validation}  `}>
                              <input
                                id={mobileNumber.name}
                                name={mobileNumber.name}
                                value={mobileNumber.value}
                                maxLength={`${country.value.name == "India" ? 10 : 14}`}
                                placeholder={mobileNumber.placeholder}
                                onChange={(e) => onInputChange(mobileNumber.name, e.target.value)}
                                onBlur={() => onBlurChange(mobileNumber.name)}
                                onClick={() => faTalkToAnExpertClick({ flowName, formData, segment: "mobile number" })}
                                required={mobileNumber.required}
                                type="text"
                                inputMode="tel"
                                aria-required="true"
                                aria-invalid={!!mobileNumber.error}
                                aria-describedby={`${mobileNumber.name}-error`}
                              />
                            </div>
                          </div>

                          <div
                            className={`${options} ${showCountryList ? active : ""}`}
                            ref={searchCountryNameRef}
                            role="listbox"
                            aria-label="Country list"
                            tabIndex={showCountryList ? 0 : -1}
                          >
                            <input
                              type="text"
                              className={`${search_box} ${search_country}`}
                              value={searchCountryName}
                              placeholder="Search Country Name"
                              onChange={(e) => updateSearchCountryList(e.target.value)}
                              aria-label="Search country"
                            />
                            <ol>
                              {countryList?.map((country, index) => {
                                return (
                                  <li
                                    key={index}
                                    className={option}
                                    onClick={() => {
                                      handleCountryClick(country);
                                    }}
                                    role="option"
                                    aria-selected={country.value === country.value}
                                    tabIndex={0}
                                    onKeyDown={e => {
                                      if (e.key === "Enter" || e.key === " ") handleCountryClick(country);
                                    }}
                                  >
                                    <div>
                                      <span className={iconify}>
                                        <img src={`${FLAG_PATH_SRC}${country?.path} `} alt={`${country.name} flag`} />
                                      </span>
                                      <span className={country_name}>{country.name}</span>
                                    </div>
                                    <strong>+{country.phone}</strong>
                                  </li>
                                );
                              })}
                            </ol>
                          </div>
                        </div>
                        <small
                          id={`${mobileNumber.name}-error`}
                          className={`${mobileNumber.touched ? (mobileNumber.error ? showMobileError : "") : ""}`}
                          aria-live="polite"
                        >
                          {mobileNumber.error}
                        </small>
                      </div>
                      <div className={` ${form_group}`}>
                        <div className={`${validation} ${companyName.touched ? (companyName.error ? error : success) : ""} `}>
                          <label htmlFor={companyName.name}>Company Name</label>
                          <input
                            id={companyName.name}
                            name={companyName.name}
                            value={companyName.value}
                            placeholder={companyName.placeholder}
                            onChange={(e) => onInputChange(companyName.name, e.target.value)}
                            onBlur={() => onBlurChange(companyName.name)}
                            onClick={() => faTalkToAnExpertClick({ flowName, formData, segment: "company name" })}
                            required={companyName.required}
                            type="text"
                            aria-required="true"
                            aria-invalid={!!companyName.error}
                            aria-describedby={`${companyName.name}-error`}
                          />
                          <small
                            id={`${companyName.name}-error`}
                            className={errorState}
                            aria-live="polite"
                          >
                            {companyName.error}
                          </small>
                        </div>
                      </div>
                      <div className={` ${form_group}`}>
                        <div className={`${validation} ${companyEmail.touched ? (companyEmail.error ? error : success) : ""} `}>
                          <label htmlFor={companyEmail.name}>Company Email</label>
                          <input
                            id={companyEmail.name}
                            name={companyEmail.name}
                            value={companyEmail.value}
                            placeholder={companyEmail.placeholder}
                            onChange={(e) => onInputChange(companyEmail.name, e.target.value)}
                            onClick={() => faTalkToAnExpertClick({ flowName, formData, segment: "company email" })}
                            onBlur={() => onBlurChange(companyEmail.name)}
                            required={companyEmail.required}
                            type="email"
                            aria-required="true"
                            aria-invalid={!!companyEmail.error}
                            aria-describedby={`${companyEmail.name}-error`}
                          />
                          <small
                            id={`${companyEmail.name}-error`}
                            aria-live="polite"
                          >
                            {companyEmail.error}
                          </small>
                        </div>
                      </div>
                      <div className={` ${form_group}`}>
                        <ShowSubmitBtn
                          formData={formData}
                          submitFormData={submitFormData}
                          flowName={flowName}
                          LeadProduct={LeadProduct}
                          LineOfBusiness={LineOfBusiness}
                          onTalkToExpertSubmitCallback={onSubmit}
                        />
                      </div>
                    </div>
                  </form>
                </>
              ) : (
                <>
                  <SubmitFormResponse status={submitFormStatus} content={submitFormContent} onClick={CloseTalkToAnExpert} />
                </>
              )}
            </div>
            <div className={right_img_wrapper} aria-hidden="true">
              <img src={`${B2B_BASE_ASSETS_URL}widgets/image/contact_pic.png`} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className={bg_overlay} tabIndex={-1} aria-hidden="true"></div>
    </div>
  );
}

const ShowSubmitBtn = memo(({ formData, submitFormData, flowName, LeadProduct, LineOfBusiness, onTalkToExpertSubmitCallback }) => {
  const pageUrl = window.location.href;
  // const location = useLocation();
  const searchParams = new URLSearchParams(window.location.search);
  let utmParams = { utm_medium: "", utm_source: "", utm_campaign: "" };
  utmParams.utm_medium = searchParams.get("utm_medium") || utmParams.utm_medium;
  utmParams.utm_source = searchParams.get("utm_source") || utmParams.utm_source;
  utmParams.utm_campaign = searchParams.get("utm_campaign") || utmParams.utm_campaign;
  let isValid = true;

  const handleSubmitForm = (e) => {
    faTalkToAnExpertClick({ flowName, formData, segment: "submit" });
    submitFormData(e, formData, LeadProduct, LineOfBusiness, pageUrl, utmParams);
    onTalkToExpertSubmitCallback && onTalkToExpertSubmitCallback();
  };

  Object.keys(formData).forEach((key) => {
    const { required, touched, error, value } = formData[key];
    if ((required && value == "") || error?.length > 0) {
      isValid = false;
    }
  });
  const SubmitBtn = isValid ? (
    <button onClick={(e) => handleSubmitForm(e)}>Submit Request</button>
  ) : (
    <button disabled="disabled">Submit Request</button>
  );
  return SubmitBtn;
});

const SubmitFormResponse = memo(({ status, content, onClick }) => {
  if (status == LOADING) {
    return <LineLoader show={true} />;
  }

  const { StatusCode, StatusMessage } = content;
  const ResponseComponents = {
    "CreateLeadS-00": { name: SuccessResponse },
    // "CreateLeadE-01": { name: ErrorResponse, message: "Alternate Phone Number is mandatory" },
    // "CreateLeadE-02": { name: ErrorResponse, message: "First Name is mandatory" },
    // "CreateLeadE-03": { name: ErrorResponse, message: "Source is mandatory" },
    // "CreateLeadE-04": { name: ErrorResponse, message: "Lead Product is mandatory" },
    "CreateLeadE-05": {
      name: DuplicateResponse,
    },
    // "CreateLeadE-06": { name: ErrorResponse, message: "Agent OLM Id or Mobile No any one is mandatory" },
    // "CreateLeadE-07": { name: ErrorResponse, message: "Technical Error. Please try again" },
    // "CreateLeadE-08": { name: ErrorResponse, message: "Please enter a valid Contact number" },
  };
  const Component = ResponseComponents[StatusCode];
  if (Component) {
    const { name: Name, message } = Component;
    return <Name message={message} apiMessage={StatusMessage} onClick={onClick} />;
  }
  return <ErrorResponse onClick={onClick} />;
});

const SuccessResponse = memo(({ onClick }) => {
  return (
    <div className={thanks_msg} id="thanku">
      <div className={message_inside}>
        <div>
          <img src={`${B2B_BASE_ASSETS_URL}b2b-components-wp/image/successful.svg`} alt="Successfully" />
        </div>
        <h5>Thank you !</h5>
        <p>
          We’ve received your request. We will contact you within <span>1 business day</span>.
        </p>
      </div>
      <a href="javascript:void(0);" className={close_got_it} onClick={onClick}>
        Ok. Got it !
      </a>
    </div>
  );
});

const DuplicateResponse = memo(({ onClick }) => {
  return (
    <div className={duplicate_msg} id="duplicate">
      <div className={message_inside}>
        <div>
          <img src={`${B2B_BASE_ASSETS_URL}b2b-components-wp/image/warning.svg`} alt="duplicate" />
        </div>
        <h5>We’re Sorry</h5>
        <p>
          There is already an existing Lead with provided details. Please try <span>after 24 hours.</span>
        </p>
      </div>
      <a href="javascript:void(0);" className={close_got_it} onClick={onClick}>
        Ok. Got it !
      </a>
    </div>
  );
});
const ErrorResponse = memo(({ onClick }) => {
  return (
    <div className={error_msg} id="invalid">
      <div className={message_inside}>
        <div>
          <img src={`${B2B_BASE_ASSETS_URL}b2b-components-wp/image/oops-image.svg`} alt="oops" />
        </div>
        <h5>
          <strong>Oops!</strong>
        </h5>
        <p>Something went wrong.</p>
      </div>
      <a href="javascript:void(0);" className={close_got_it} onClick={onClick}>
        Ok. Got it !
      </a>
    </div>
  );
});
